/**
 * filter
 */

import $ from 'jquery';
import Range from './range';
import Page from 'js/lib/page';
import pubsub from 'pubsub-js';

export default class Filter extends Page {
  init() {
    this.ranges = [];

    this.elements({
      section: '.js-filter-section',
      toggle: '.js-filter-toggle',
      body: '.js-filter-body',
      range: '.js-filter-range'
    });

    this.events({
      'click.toggle': {
        target: this.$.toggle,
        data: { type: 'toggle' },
        handler: e => this.handler(e)
      },
      change: {
        target: this.$.root,
        handler: e => this.renderTooltip(e)
      }
    });

    this.range();
    this.hide();
    this.show();
  }
  hide() {
    this.$.section
      .not('.is-open')
      .find(this.$.body)
      .hide();
  }
  show() {
    this.$.root.addClass('is-inited');
  }
  range() {
    $.each(this.$.range, (i, range) => this.ranges.push(new Range(range)));
  }
  handler(e) {
    const $target = $(e.target);
    const $section = $target.closest(this.$.section);
    const $body = $section.find(this.$.body);

    switch (e.data.type) {
      case 'toggle':
        this.toggle([$target, $section, $body]);
        break;
    }
  }
  toggle($elements) {
    const [, $section] = $elements;

    if ($section.is('.is-open')) {
      this.close($elements);
    } else {
      this.open($elements);
    }
  }
  close($elements) {
    const [$target, $section, $body] = $elements;

    $target.removeClass('is-active');
    $section.removeClass('is-open');
    $body.slideUp();
  }
  open($elements) {
    const [$target, $section, $body] = $elements;

    $target.addClass('is-active');
    $section.addClass('is-open');
    $body.slideDown();
  }
  renderTooltip(e) {
    const values = this.$.root.serialize();
    const url = '/filter';
    const $target = $(e.target);
    const $section = $target.closest(this.$.section);

    $.post(url, values, ({ content, amount }) => {
      if ('tooltip' in this.$ && this.$.tooltip.length) {
        this.$.tooltip.remove();
      }

      this.$.tooltip = $(content);

      $section.prepend(this.$.tooltip);

      pubsub.publish('content.update', { amount });
    });
  }
}

Page.make(Filter, '.js-filter');
